import { useState } from 'react'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'

import ApplicationForm from '../../components/applications/ApplicationForm.jsx'
import { deleteApplication, updateApplication } from '../../api/applications.js'
import { useFeedback } from '../../components/ui/FeedbackProvider.jsx'

export default function ApplicationSettingsPage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const { application, onApplicationUpdated } = useOutletContext()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitError, setSubmitError] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false)
  const [deleteError, setDeleteError] = useState(null)
  const [successMessage, setSuccessMessage] = useState('')
  const { confirm } = useFeedback()

  async function handleSubmit(values) {
    if (!id || isSubmitting) return

    setIsSubmitting(true)
    setSubmitError(null)
    setSuccessMessage('')

    try {
      const updatedApplication = await updateApplication(id, values)
      onApplicationUpdated?.(updatedApplication)
      setSuccessMessage('Application settings saved.')
    } catch (error) {
      setSubmitError(error)
    } finally {
      setIsSubmitting(false)
    }
  }

  async function handleDelete() {
    if (!id || isDeleting) return
    const confirmed = await confirm({
      title: 'Delete application',
      message: 'Delete this application? This action cannot be undone.',
      confirmLabel: 'Delete',
      tone: 'danger',
    })
    if (!confirmed) return

    setIsDeleting(true)
    setDeleteError(null)

    try {
      await deleteApplication(id)
      navigate('/applications')
    } catch (error) {
      setDeleteError(error)
      setIsDeleting(false)
    }
  }

  return (
    <section className="settingsGrid">
      <ApplicationForm
        key={`${application.id}-${application.updatedAt || ''}`}
        initialValues={application}
        onSubmit={handleSubmit}
        submitLabel="Save changes"
        isSubmitting={isSubmitting}
        error={submitError}
        disabled
      />

      <section className="card settingsDangerCard">
        <div className="cardTitle">Danger zone</div>
        <button
          className="button buttonGhost buttonDanger"
          type="button"
          onClick={handleDelete}
          disabled={isDeleting}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </button>
        {deleteError ? (
          <div className="formError">{String(deleteError.message || deleteError)}</div>
        ) : null}
      </section>

      {successMessage ? <div className="settingsSuccess">{successMessage}</div> : null}
    </section>
  )
}
